/// <amd-module name="VSSUI/Panel" />
export { CustomPanel } from "./Components/Panel/CustomPanel";
export { Panel } from "./Components/Panel/Panel";
export { PanelCloseButton } from "./Components/Panel/PanelCloseButton";
export { PanelContent } from "./Components/Panel/PanelContent";
export { PanelFooter } from "./Components/Panel/PanelFooter";
export { PanelHeader } from "./Components/Panel/PanelHeader";
export { PanelOverlay } from "./Components/Panel/PanelOverlay";

export {
    ICustomPanelProps,
    IPanelProps,
    IPanelCloseButtonProps,
    IPanelContentProps,
    IPanelFooterProps,
    IPanelOverlayProps,
    IPanelTitleProps,
    PanelCloseButtonSize
} from "VSSUI/Components/Panel/Panel.Props";
